import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { RoutePath } from 'src/app/shared/model/enum';
import { UnlinkAlternativePartComponent } from '../../../../parts-and-inventory/parts-list/popup/unlink-alternative-part/unlink-alternative-part.component';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { SendDataService } from '../../../../../shared/services/send-data.service';

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit, ICellRendererAngularComp {
  params: any;
  routePath;
  routeUrl =  RoutePath;
  constructor(private route : Router, public sendDataService: SendDataService,) { }
  agInit(params: ICellRendererParams) {

    this.params = params;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
    this.routePath = this.route.url
  }

  onSelectChange(event): void {
    this.params.data.action = event;
 
  }
  onClick(params){
    const data =params?.data
    this.sendDataService.openModalPopup(UnlinkAlternativePartComponent, data, 'Unlink Alternative Part', ModalPopupSize.SM, 'link-popup').then(
      (resultData) => {
        if (resultData.confirm) {
           this.params.resultData = resultData
            const customEvent = new CustomEvent('linkCellClick', {
              detail: { data: this.params },
            });
            document.dispatchEvent(customEvent);
        }
      }
    );
  }

  getDynamicId(params: any): string {
    if (this.routePath?.includes(RoutePath.PARTLIST_IMPORT_ROUTEPATH)) {
      return `${params?.data?.mpn}${params?.data?.rowNo}`;
    } else if (this.routePath !== this.routeUrl.CODECROSSWALK_ROUTEPATH) {
      return `${params?.data?.companyName}${params?.data?.id}`;
    } else {
      return `${params?.data?.industry}${params?.data?.rowNo}`;
    }
  }
}
